import React from 'react';
import { resolveUserColor, type UserColorIndex } from '../../utils/userColorIndex';
import type { SmartSelectOption } from '../dropdown';

/** Initials (max 2) from a technician's display name. */
const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? '')
    .join('') || '?';

/**
 * Build the avatar + name renderItem for the technician SmartSelect. Colours
 * come from each user's assigned avatar colour via the shared user-colour index
 * (seeded by the stable user id for unassigned users), so a technician's colour
 * matches everywhere else in the app — not a one-off hash of the name.
 */
export const makeTechnicianRenderItem = (index: UserColorIndex) =>
  (option: SmartSelectOption) => {
    const colour = resolveUserColor(index, { name: option.value });
    return (
      <>
        <span
          className="sm4rt-select__avatar"
          style={{ background: colour.bg, color: colour.fg }}
        >
          {initials(option.label)}
        </span>
        <span className="sm4rt-dd__label">{option.label}</span>
      </>
    );
  };
